import { uuid } from "../utils/uuid";
import { Workbook } from "../core/Workbook";
import { generateSpreadsheetViewConfig } from "datasheets/views/spreadsheet/SpreadsheetViewConfig";
import { emptyWorkbook, newView } from "./new";

// Keep in separate file from newDataset to avoid circular dependencies
export const newWorkbook = (): Workbook => {
  const viewName = "Sheet1";
  const workbookId = uuid();
  const initialWorkbook: Workbook = emptyWorkbook();
  initialWorkbook.id = workbookId;
  const view = newView(
    viewName,
    generateSpreadsheetViewConfig(viewName, initialWorkbook)
  );
  initialWorkbook.data = {
    views: { [view.id]: view },
    viewOrder: [view.id],
    datasets: initialWorkbook.data.datasets,
  };
  initialWorkbook.operational.selectedView = view.id;
  return initialWorkbook;
};
